import { LoaderFunctionArgs } from "react-router-dom";
import { FreightBolTracking } from "../models/FreightBolTracking";

export const trackingDataLoader = async ({
  params,
}: LoaderFunctionArgs): Promise<FreightBolTracking> => {
  if (!params.bolId) {
    // Guard against the route being matched without a bolId segment.
    // Throwing a Response is the react-router idiom that lets the route's
    // errorElement read the status via isRouteErrorResponse.
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw new Response("Missing BOL ID", { status: 400 });
  }

  let trackingResults: globalThis.Response;
  try {
    trackingResults = await fetch(
      `${process.env.REACT_APP_FREIGHT_SERVICE_URL}/v1/public/tracking/order-load/bol/${params.bolId}/events`
    );
  } catch {
    // Network failure (offline, DNS, CORS) — not a missing BOL.
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw new Response("Tracking service unreachable", { status: 503 });
  }

  if (!trackingResults.ok) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw new Response("Tracking lookup failed", {
      status: trackingResults.status,
    });
  }

  let trackingDetails: FreightBolTracking;
  try {
    trackingDetails = (await trackingResults.json()) as FreightBolTracking;
  } catch {
    // Malformed JSON from the service — treat as a service error, not a
    // missing BOL, so the caller gets a consistent Response type.
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw new Response("Invalid response from tracking service", {
      status: 502,
    });
  }

  return trackingDetails;
};
